module.exports = __webpack_public_path__ + "img/stavropol-excursions.c20ee162.png";